
<router-outlet></router-outlet>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<doc-global-toast></doc-global-toast>
@if (showAuthenticatedWidgets) {
  <app-upload-indicator></app-upload-indicator>
}
@if (showAuthenticatedWidgets) {
  <app-upload-media-dialog></app-upload-media-dialog>
}
